const BookingPaymentStatuses = {
  SUCCEEDED: "succeeded",
  SUCCEEDED_FREE: "succeeded (free)",
  FAILED: "failed",
  PENDING: "pending"
};

export default BookingPaymentStatuses;
